import { render, staticRenderFns } from "./SiteVersionComments.vue?vue&type=template&id=0371da9e&scoped=true&"
import script from "./SiteVersionComments.vue?vue&type=script&lang=js&"
export * from "./SiteVersionComments.vue?vue&type=script&lang=js&"
import style0 from "./SiteVersionComments.vue?vue&type=style&index=0&id=0371da9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0371da9e",
  null
  
)

export default component.exports